import React, { useCallback, useState, useEffect, useContext } from "react";
import { UserDataContext,ContextFromSelections, ShoppingCartContext,TotalShopCartPriceContext } from "./Context";
import {loadStripe} from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import {
  useNavigate
} from "react-router-dom";
import { useNotify, validateToken } from "./Utils";
import { Button,Box,Typography } from "@mui/material";
import { closeSnackbar } from "notistack";
import CircularProgress from '@mui/material/CircularProgress';





const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_API_KEY);

export const CheckoutForm = () => {
  
  const [userData] = useContext(UserDataContext)
  const [shopCart,_] = useContext(ShoppingCartContext)
  const [selections] = useContext(ContextFromSelections)
  const navigate = useNavigate();
  const formdata = new FormData();
  formdata.append("shopcart", shopCart)

  



    const fetchClientSecret = useCallback(async() => {
      try {
        const token  = await validateToken({userData})
        const fetching = await fetch(`${process.env.REACT_APP_API_URL}/create-checkout-session`, {
        "method": "POST",
        "credentials": "include",
        "body": formdata,
        "headers": {
          "Authorization": `Bearer ${token}`,
        }
      })
      const fetchingJson = await fetching.json();
      return fetchingJson.client_secret;
      }

      catch (error) {
        console.log(error)
    
    }
  },[userData.userToken]);

 
  const options = {fetchClientSecret};


  return (
  
    userData.userToken &&
   
  
          <Box id="checkout">
             <EmbeddedCheckoutProvider
               stripe={stripePromise}
               options={options}>
               <EmbeddedCheckout />
             </EmbeddedCheckoutProvider>
             <Box  sx={{
               display: "flex",
               width: "100%", 
               alignItems: "center",
               justifyContent: "center",
               margin: "auto",
              
               paddingTop: 2,
               paddingBottom: 3,
               }}>
               <Button 
                 variant="outlined"
                 color="primary"
                 onClick={()=> navigate("/")}
                 sx={{
                   width: 378,
                   height: 35,
                 }}
                 >
                 Cancel   CheckOut
                 </Button>
             </Box>
         </Box>
      );
    
  };
  

  
  
export function Return() {
  const [status, setStatus] = useState(null);
  const [userData] = useContext(UserDataContext);
  const [_,setShopCart] = useContext(ShoppingCartContext)
  const [, setSelectedData] = useContext(ContextFromSelections);
  const navigate = useNavigate();
  const notify = useNotify();

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get("session_id");

    const getSessionData = async () => {
      const token = await validateToken({ userData });
      try {
        const fetching = await fetch(
          `${process.env.REACT_APP_API_URL}/create-checkout-session?session_id=${sessionId}`,
          {
            credentials: "include",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const resp = await fetching.json();
        setStatus(resp.status);
        setShopCart(resp.shopcart)
      } catch (error) {
        return null 
      }
    };

    getSessionData();
  }, [userData.userToken]);



  useEffect(() => {
    if (status === "open") {
      navigate("/checkout");
    }

    if (status === "complete") {
      notify({
        message: `Your payment has been successfully processed!
                  A receipt has been sent to your email address. Please check your inbox for the details.
                  If you have any questions, feel free to contact us.`,
        variant: "success",
        persist: true,
        action: (key) => (
          <Button color="text.secondary" onClick={() => closeSnackbar(key)}>
            ok
          </Button>
        ),
      });

      localStorage.removeItem("selectionStorage");
      setSelectedData({});
      navigate("/");
    }
  }, [status, navigate, setSelectedData]);

  useEffect(() => {
  if (status === null) {
    const timer = setTimeout(() => {
      notify({message: "cant sync with server please try again later",variant: "error",duration:2000})
      navigate("/"); 
    }, 10000);
    return () => clearTimeout(timer);
  }
  }, [status, navigate]); 

  if (!status) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          width: "100%",
          gap: 2,
        }}
      >
        <CircularProgress size={80} />
        <Typography>Almost done ...</Typography>
      </Box>
    );
  }

  return null; 
}

  


